import Util from "commons/util/util";

export const triggerStoreViewed = ({
  storeId,
  storeName,
  terminal,
  sector,
  movementType,
}) => {
  Util.triggerMoEngageEvent("store_viewed", {
    store_id: storeId,
    store_name: storeName,
    terminal: terminal,
    sector: sector,
    movement_type: movementType,
  });
};
